import { isIframeFullscreen } from 'src/modules/designStudio/helpers/fullscreenIframe';
import { Mode } from 'src/modules/designStudio/providers';

import { useFullscreenConfig } from '../useFullscreenConfig';

const useShouldDisplayToolbar = (mode: Mode): boolean => {
  const { onlyDisplayToolbarInFullscreen } = useFullscreenConfig();
  const iframeIsFullscreen = isIframeFullscreen();
  const modeIsPreview = mode === Mode.PREVIEW;
  if (onlyDisplayToolbarInFullscreen) {
    return iframeIsFullscreen && !modeIsPreview;
  }
  return !modeIsPreview;
};

export { useShouldDisplayToolbar };
